<template>
  <div>
    <div
      v-if="popupType !== 'thank_you'"
      class="over-lay"
      @click="closePopup()"
    ></div>
    <div v-else class="over-lay" @click="closeThankPopup()"></div>
    <div
      class="popup"
      :class="[
        { 'p-t-25': popupType === 'linkedin_follow' },
        { 'p-t-35': popupType === 'thank_you' }
      ]"
    >
      <span
        v-if="popupType !== 'thank_you'"
        class="close-hldr"
        @click="closePopup()"
      >
        <i class="material-icons">close</i>
      </span>
      <span
        v-if="popupType === 'thank_you'"
        class="close-hldr"
        @click="closeThankPopup()"
      >
        <i class="material-icons">close</i>
      </span>
      <Rocket-View
        class="upgrade-rocket"
        v-if="popupType !== 'linkedin_follow' && popupType !== 'thank_you'"
      />
      <Cracker-Icon
        class="intro-cracker"
        v-if="popupType === 'linkedin_follow'"
      />
      <Trophy-Icon class="trophy" v-if="popupType === 'thank_you'" />
      <div class="hdr">{{ upgradePopup.title }}</div>
      <div class="thanks-section" v-if="popupType !== 'fair_usage_limit'">
        {{ upgradePopup.message }}
        <b class="download-count" v-if="popupType === 'promo_unlimited_copy'">{{
          upgradePopup.downloadLeft
        }}</b>
        <span
          v-if="popupType === 'promo_unlimited_copy'"
          class="promo-copy-section"
        >
          {{ upgradePopup.firstText }}
          <b>{{ upgradePopup.boldText }}</b>
          {{ upgradePopup.lastText }}
        </span>
        <span v-if="popupType === 'daily_limit'">
          {{ upgradePopup.firstText }}
          <b>{{ upgradePopup.boldText }}</b>
          <br />
          {{ upgradePopup.lastText }}
        </span>
      </div>
      <div class="thanks-section" v-else>
        You have reached your daily usage limit. You can resume purchasing
        contacts at 6AM PST. Please upgrade to a higher plan to increase or
        remove the limit. Contact us at
        <a href="mailto:success@adapt.io">success@adapt.io</a> if you have any
        questions.
      </div>
      <div
        class="btn-section d-flex"
        v-if="popupType !== 'linkedin_follow' && popupType !== 'thank_you'"
      >
        <!-- <V-Button
          :className="'btn-blue'"
          :text="`7 DAY FREE TRIAL *`"
          :callback="upgradeTrial"
        ></V-Button>-->
        <V-Button
          :className="'cancelBtn'"
          :text="upgradePopup.buttonText || 'BUY NOW'"
          :callback="upgradeBuyNow"
        ></V-Button>
      </div>
      <div class="g2Review-section" v-if="popupType === 'daily_limit'">
        <div class="seperater">OR</div>
        <span>
          Give us a review in G2 and
          <br />contact <a href="mainto:support@adapt.i">support@adapt.io</a> to
          remove your daily limit.
        </span>
      </div>
      <div
        class="btn-section d-flex g2Review-btn"
        v-if="popupType === 'daily_limit'"
      >
        <V-Button
          :className="'cancelBtn'"
          :text="upgradePopup.g2BtnText"
          :callback="goToG2Review"
        ></V-Button>
      </div>
      <div
        class="policy-text"
        v-if="
          popupType !== 'linkedin_follow' &&
            popupType !== 'thank_you' &&
            popupType !== 'fair_usage_limit'
        "
      >
        {{ trustPolicy }}
      </div>
      <div
        class="btn-section got-it-btn d-flex"
        v-if="popupType === 'thank_you'"
      >
        <V-Button
          :className="'cancelBtn'"
          :text="'Got It'"
          :callback="closeThankPopup"
        ></V-Button>
      </div>
      <!-- <div
        class="plan-text"
        v-if="
          popupType !== 'download' &&
            popupType !== 'thank_you' &&
            canShowLinkedinFollow &&
            !showLinkedinFollow &&
            !isPaidUser
        "
      >
        <div class="extra-view-text" v-if="popupType !== 'linkedin_follow'">
          Follow us on LinkedIn to
          <br />get
          <b>25</b> free contacts
        </div>
        <div class="follow-li-btn">
          <button v-if="!showLiFollowLoader" @click="followLinkedin">
            <i class="fa fa-linkedin"></i>
            <span>Follow</span>
          </button>
          <Spinner v-else />
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import rocketViewsIcon from '@/assets/icons/svg/rocket.svg'
import crackerIcon from '@/assets/icons/svg/cracker.svg'
import trophyIcon from '@/assets/icons/svg/trophy.svg'
import button from '@/components/Button'
// import Spinner from '@/components/Spinner'
import sharedFunction from '@/assets/util/functions.js'
import { MxEvent, HttpUrl } from '@/assets/util/constants/analytics.js'
import { post } from '@/assets/util/rest.js'
import {
  BASE_URL_NEW,
  G2_REVIEW_LINK
} from '@/assets/util/constants/constants.js'

export default {
  name: 'Add-Domain-Find-Email',
  props: ['text', 'data', 'upgradePopupType'],
  watch: {
    upgradePopupType: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.upgradeType(newValue)
        }
      }
    }
  },
  data: function() {
    return {
      showPopup: false,
      domain: '',
      companyName: '',
      upgradePopup: {},
      isSalesNavigator: this.$store.state.isSalesNavigator,
      trustPolicy: `*No Contracts. No Obligations. Cancel Anytime.`,
      dataMap: {},
      popupType: '',
      loader: true,
      showLiFollowLoader: false,
      isPaidUser: this.$store.state.header.isPaidUser,
      showLinkedinFollow: this.$store.state.header.linkedinFollow,
      canShowLinkedinFollow: this.$store.state.header.canShowLinkedinFollow
    }
  },

  components: {
    'V-Button': button,
    'Rocket-View': rocketViewsIcon,
    'Cracker-Icon': crackerIcon,
    // Spinner,
    'Trophy-Icon': trophyIcon
    // 'Linkedin-Icon': linkedinIcon
  },
  methods: {
    closePopup() {
      sharedFunction.track(MxEvent.payWallClosed, null, this.$store.state)
      this.$emit('clickedOutside', true)
    },
    closeThankPopup() {
      sharedFunction.track(MxEvent.followLinkedinClose, null, this.$store.state)
      this.$emit('clickedOutside', true)
    },
    upgradeTrial() {
      this.dataMap = {
        popupType: this.upgradeBtnType(this.popupType, 'Trial')
      }
      sharedFunction.track(
        MxEvent.payWallClicked,
        this.dataMap,
        this.$store.state
      )
      window.open(`${BASE_URL_NEW}/pricing`)
    },
    upgradeBuyNow() {
      this.dataMap = {
        popupType: this.upgradeBtnType(this.popupType, 'Buy Now')
      }
      sharedFunction.track(
        MxEvent.payWallClicked,
        this.dataMap,
        this.$store.state
      )
      window.open(`${BASE_URL_NEW}/pricing`)
    },
    goToG2Review() {
      this.dataMap = {
        popupType: this.upgradeBtnType(this.popupType, 'RATE US ON G2')
      }
      sharedFunction.track(
        MxEvent.dailyLimitG2Review,
        this.dataMap,
        this.$store.state
      )
      window.open(G2_REVIEW_LINK, '_blank')
    },
    upgradeBtnType(type, pricingType) {
      let propValue = ''
      switch (type) {
        case 'download':
          propValue = `No Download - ${window.location.pathname} - ${pricingType}`
          break
        case 'bulk':
          propValue = `Bulk Upgrade Remove Limit - ${window.location.pathname} - ${pricingType}`
          break
        case 'sales_navigator':
          propValue = `Sales Navigator Upgrade - ${window.location.pathname} - ${pricingType}`
          break
        case 'li_connect_skip':
          propValue = `LinkedIn Connect Skip - ${window.location.pathname} - ${pricingType}`
          break
        case 'li_connect_multi':
          propValue = `Bulk LinkedIn Connect - ${window.location.pathname} - ${pricingType}`
          break
        case 'Salesforce':
          propValue = `CRM Export ${type} - ${window.location.pathname} - ${pricingType}`
          break
        case 'Outreach':
          propValue = `CRM Export ${type} - ${window.location.pathname} - ${pricingType}`
          break
        case 'Hubspot':
          propValue = `CRM Export ${type} - ${window.location.pathname} - ${pricingType}`
          break
        // case 'promo_intro_plan':
        //   propValue = `Intro Plan - ${window.location.pathname} - ${pricingType}`
        //   break
        case 'promo_unlimited_copy':
          propValue = `Unlimited copy - ${window.location.pathname} - ${pricingType}`
          break
        case 'list_enable':
          propValue = `List Management - ${window.location.pathname} - ${pricingType}`
          break
        case 'linkedin_follow':
          propValue = `Linkedin Follow - ${window.location.pathname}`
          break
        case 'thank_you':
          propValue = `Thank You - ${window.location.pathname}`
          break
        case 'daily_limit':
          propValue = `Daily Limit - ${window.location.pathname}`
          break
        case 'phone':
          propValue = `No Phone Credits - ${window.location.pathname}`
          break
        case 'phone_locked':
          propValue = `Mobile Feature Locked - ${window.location.pathname}`
          break
        case 'phone_free_user':
          propValue = `Free User Upgrade - ${window.location.pathname}`
          break
        default:
          propValue = `No contacts - ${window.location.pathname} - ${pricingType}`
          break
      }
      return propValue
    },
    upgradeType(type) {
      this.popupType = type
      switch (type) {
        case 'download':
          this.upgradePopup = {
            title: 'Upgrade to continue',
            message:
              'You have run out of downloads. Please upgrade to continue.'
          }
          this.dataMap[
            'popupType'
          ] = `No Download - ${window.location.pathname}`
          break
        case 'bulk':
          this.upgradePopup = {
            title: 'Upgrade to continue',
            message:
              'You can view a maximum of 10 emails from the search results page. To continue to view more emails, please upgrade to one of our premium plans'
          }
          this.dataMap[
            'popupType'
          ] = `Bulk Upgrade Remove Limit - ${window.location.pathname}`
          break
        case 'sales_navigator':
          this.upgradePopup = {
            title: 'Upgrade to continue',
            message:
              'Prospector for Sales Navigator is a premium feature available only on our paid subscriptions.'
          }
          this.dataMap[
            'popupType'
          ] = `Sales Navigator Upgrade- ${window.location.pathname}`
          break
        case 'li_connect_skip':
          this.upgradePopup = {
            title: 'Upgrade to continue',
            message: 'and skip profile verification'
          }
          this.dataMap[
            'popupType'
          ] = `LinkedIn Connect Skip - ${window.location.pathname}`
          break
        case 'li_connect_multi':
          this.upgradePopup = {
            title: 'Upgrade to continue',
            message:
              'This LinkedIn profile is already connected with another account'
          }
          this.dataMap[
            'popupType'
          ] = `Bulk LinkedIn Connect - ${window.location.pathname}`
          break
        case 'Salesforce':
          this.upgradePopup = {
            title: 'Upgrade to continue',
            message: `${type} export is a premium feature available only on our paid subscriptions.`
          }
          this.dataMap[
            'popupType'
          ] = `No Download - ${window.location.pathname}`
          break
        case 'Outreach':
          this.upgradePopup = {
            title: 'Upgrade to continue',
            message: `${type} export is a premium feature available only on our paid subscriptions.`
          }
          this.dataMap[
            'popupType'
          ] = `No Download - ${window.location.pathname}`
          break
        case 'Hubspot':
          this.upgradePopup = {
            title: 'Upgrade to continue',
            message: `${type} export is a premium feature available only on our paid subscriptions.`
          }
          this.dataMap[
            'popupType'
          ] = `No Download - ${window.location.pathname}`
          break
        // case 'promo_intro_plan':
        //   this.upgradePopup = {
        //     title: 'Introducing',
        //     message: '',
        //     feature: [
        //       'Unlimited Copy',
        //       'List Management',
        //       'Prospector for Sales Navigator'
        //     ]
        //   }
        //   this.dataMap['popupType'] = `Intro Plan - ${window.location.pathname}`
        //   break
        case 'promo_unlimited_copy':
          this.upgradePopup = {
            title: 'Get Unlimited Copy',
            message: `Copy reduces downloads in our free plan.`,
            downloadLeft: `${
              this.$store.state.header.downloads > 0
                ? this.$store.state.header.downloads
                : 'No'
            } download${
              this.$store.state.header.downloads > 1 ||
              this.$store.state.header.downloads === 0
                ? 's'
                : ''
            } remaining`,
            firstText: `Upgrade to get `,
            boldText: `unlimited copy `,
            lastText: `in our paid subscriptions.`
          }
          this.dataMap[
            'popupType'
          ] = `Unlimited Copy - ${window.location.pathname}`
          break
        case 'list_enable':
          this.upgradePopup = {
            title: 'Upgrade to continue',
            message: `List Management is a premium feature available only on our paid subscriptions.`
          }
          this.dataMap[
            'popupType'
          ] = `List Mangement - ${window.location.pathname}`
          break
        case 'linkedin_follow':
          this.upgradePopup = {
            title: 'Get Free credits',
            message: `Join the Adapt community on LinkedIn and get the latest updates, in addition to 25 free credits!`
          }
          this.dataMap[
            'popupType'
          ] = `LinkedIn Follow - ${window.location.pathname}`
          break
        case 'thank_you':
          this.upgradePopup = {
            title: `Thanks. You're awesome!`,
            message: `We've added 25 credits to your account, as promised.`
          }
          this.dataMap['popupType'] = `Thank You - ${window.location.pathname}`
          break
        case 'daily_limit':
          this.upgradePopup = {
            title: `Daily Limit Reached`,
            // message: `Get on one of our premium plans to remove daily limits`
            firstText: `You have reached your daily limit of`,
            boldText: ` ${this.$store.state.header.dailyLimit} credits/day.`,
            lastText: ` Please upgrade to one of our premium plans.`,
            g2BtnText: 'RATE US ON G2'
          }
          this.dataMap[
            'popupType'
          ] = `Daily Limit - ${window.location.pathname}`
          break
        case 'fair_usage_limit':
          this.upgradePopup = {
            title: `Daily Usage Limit Reached`,
            buttonText: 'Upgrade Now'
          }
          this.dataMap[
            'popupType'
          ] = `Fair Usage Limit - ${window.location.pathname}`
          break
        case 'phone':
          this.upgradePopup = {
            title: 'Upgrade to continue',
            message:
              'You have run out of phone credits. Please upgrade to continue.',
            buttonText: 'Upgrade'
          }
          this.dataMap[
            'popupType'
          ] = `No phone credits - ${window.location.pathname}`
          break
        case 'phone_locked':
          this.upgradePopup = {
            title: 'Upgrade to continue',
            message:
              'You do not have access to mobile numbers. Please upgrade to continue.',
            buttonText: 'Upgrade'
          }
          this.dataMap[
            'popupType'
          ] = `Mobile number locked - ${window.location.pathname}`
          break
        case 'phone_free_user':
          this.upgradePopup = {
            title: 'Upgrade to continue',
            message:
              'Mobile numbers are a premium feature available only on our paid subscriptions.'
          }
          this.dataMap[
            'popupType'
          ] = `Free User Upgrade - ${window.location.pathname}`
          break
        default:
          this.upgradePopup = {
            title: 'Upgrade to continue',
            message: 'You have run out of credits. Please upgrade to continue.'
          }
          this.dataMap[
            'popupType'
          ] = `No contacts - ${window.location.pathname}`
          break
      }
      sharedFunction.track(
        type == 'linkedin_follow'
          ? MxEvent.followLinkedinShown
          : MxEvent.payWallViewed,
        this.dataMap,
        this.$store.state
      )
    },
    followLinkedin() {
      this.showLiFollowLoader = true
      if (
        !this.$store.state.header.isPaidUser &&
        !this.$store.state.header.linkedinFollow
      ) {
        post(HttpUrl.linkedinFollow).then(response => {
          if (response.status == 200) {
            response.json().then(res => {
              sharedFunction.track(
                MxEvent.followLinkedinClick,
                {},
                this.$store.state
              )
              localStorage.setItem('linkedin_follow_msg_shown', true)
              if (res) {
                const dataMap = {
                  data: '',
                  type: 'CLICKING_FOLLOW_BTN'
                }
                window.postMessage(dataMap, '*')
                setTimeout(() => {
                  if (this.$store.state.header.lbCreditsPlan) {
                    this.$store.state.header.credits =
                      parseInt(this.$store.state.header.credits) + 25
                  } else {
                    this.$store.state.header.views =
                      parseInt(this.$store.state.header.views) + 25
                  }
                  this.$store.state.header.linkedinFollow = true
                  this.showLiFollowLoader = false
                  this.upgradeType('thank_you')
                }, 1500)
              }
            })
          }
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.p-t-25 {
  padding-top: 20px !important;
}
%svg-img {
  width: 60px !important;
  height: 60px !important;
}
.over-lay {
  background: rgb(0, 0, 0, 0.85);
  position: fixed;
  height: 100%;
  top: 0px;
  width: 100%;
  left: 0;
  z-index: 3;
}
.popup {
  position: fixed;
  width: 85%;
  color: #474542;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  will-change: transform;
  border-radius: 6px;
  background-color: $white;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 50px;
  padding-bottom: 0px;
  line-height: initial;
  .close-hldr {
    position: absolute;
    right: 12px;
    top: 12px;
    display: flex;
    i {
      font-size: 15px;
      cursor: pointer;
      color: #787878;
    }
  }
  .upgrade-rocket {
    @extend %svg-img;
    position: absolute;
    top: -25px;
    -webkit-animation: MoveUpDown 2s infinite alternate;
    animation: MoveUpDown 2s infinite alternate;
  }
  .intro-cracker {
    width: 50px;
    height: 50px;
    padding-bottom: 5px;
    position: relative;
    animation: spreadBlink 3s 1 ease-in;
    animation-fill-mode: forwards;
    -webkit-animation: spreadBlink 3s 1 ease-in;
    -webkit-animation-fill-mode: forwards;
  }
  .trophy {
    width: 50px;
    height: 50px;
    margin-bottom: 10px;
  }
  .positive-vote {
    @extend %svg-img;
    position: absolute;
    top: -30px;
  }
  .hdr {
    font-size: 20px;
    text-align: center;
    font-weight: 500;
    line-height: 1.35;
  }
  .sub-hdr {
    font-size: 17px;
    font-weight: 500;
    padding: 5px 0 0;
    color: $text-dark;
    b {
      color: $orange;
    }
  }
  .plan-text {
    font-size: 15px;
    width: 100%;
    background: #effff1;
    text-align: center;
    padding: 10px 0 22px;
    margin-top: 5px;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    .extra-view-text {
      font-size: 14px;
      color: $grey-color;
      margin-top: 10px;
      margin-bottom: 10px;
      line-height: 1.3;
      b {
        color: $orange;
        letter-spacing: 0.3px;
      }
    }
    .follow-li-btn {
      width: fit-content;
      margin: 0 auto;
      text-align: center;
      button {
        display: flex;
        align-items: center;
        justify-content: center;
        background: #0077b5;
        color: $white;
        width: fit-content;
        justify-content: center;
        text-transform: capitalize;
        border: none;
        border-radius: 4px;
        box-shadow: 0 0 1px 0 #0077b5;
        i {
          vertical-align: middle;
          font-size: 16px;
          border-right: 1px solid #045c8b;
          padding: 8px;
        }
        span {
          font-size: 15px;
          padding: 8px 15px 8px 8px;
          font-weight: 500;
          letter-spacing: 0.5px;
        }
        &:hover {
          box-shadow: 0 0 3px 0 #0077b5;
        }
      }
      .spinner {
        margin: 0 auto;
        height: 30px;
      }
    }
  }
  .thanks-section,
  .note-section {
    width: 80%;
    text-align: center;
    line-height: 1.4;
    font-size: 14px;
    margin-top: 15px;
    margin-bottom: 15px;
  }
  .g2Review-section {
    width: 80%;
    text-align: center;
    line-height: 1.4;
    font-size: 14px;
    margin-bottom: 5px;

    .seperater {
      margin: 5px 0;
    }
    a {
      color: $primary-color;
    }
  }
  .g2Review-btn::v-deep {
    .cancelBtn {
      color: #fff !important;
      border-color: #fc9a01 !important;
      background-color: #fc9a01;
    }
  }
  .download-count {
    display: block;
    margin-top: 10px;
  }
  .intro-section {
    width: 80%;
    margin: 0 auto;
    .intro-start-plan {
      text-align: left;
      color: $grey-color;
      &:not(:last-child) {
        margin-bottom: 10px;
      }
      font-size: 14px;
      display: flex;
      i {
        margin-right: 10px;
        color: green;
        font-size: 15px;
        align-self: flex-start;
      }
    }
  }
  .promo-copy-section {
    text-align: center;
    display: block;
    line-height: 1.4;
    font-size: 14px;
    margin-top: 7px;
    margin-bottom: 15px;
  }
  .note-section {
    width: 100%;
    padding: 24px 15%;
    margin-bottom: 17px;
    opacity: 0.85;
    font-size: 14px;
    line-height: 1.53;
    color: $text-dark;
    background-color: #f7f7f7;
    a {
      color: $primary-color;
    }
  }
  .btn-section::v-deep {
    flex-direction: column;
    &.got-it-btn {
      margin-bottom: 20px;
      button {
        font-size: 16px;
      }
    }
    button {
      width: 160px;
      padding: 10px 0px;
      margin: 5px;
      font-size: 12px;
      border: solid 1px #56a2f9;
      border-radius: 5px;
      letter-spacing: 0.3px;
      font-weight: 600;
      background-color: $white;
      &.btn-blue {
        transform: translateZ(0);
        background-color: $primary-color;
        box-shadow: 0 0 1px transparent;
        backface-visibility: hidden;
        color: $white;
        animation: tidleShake 5s linear infinite running;
        -webkit-animation: tidleShake 5s linear infinite running;
      }
      &.cancelBtn {
        color: $primary-color;
      }
    }
  }
  .policy-text {
    display: block;
    width: 200px;
    margin: 0 auto;
    padding: 10px 0;
    font-size: 13px;
    color: $grey-color;
    text-align: center;
  }
}
</style>
